import { createContext, useContext, useEffect, useState, useCallback } from "react";
import {
  TOKEN_KEY,
  getCurrentUser,
  login as loginRequest,
  logout as logoutRequest,
} from "@/api/treeplet";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = unauthenticated, object = authed

  useEffect(() => {
    let active = true;
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) {
      setUser(false);
      return;
    }
    getCurrentUser()
      .then((data) => active && setUser(data))
      .catch(() => {
        localStorage.removeItem(TOKEN_KEY);
        if (active) setUser(false);
      });
    return () => {
      active = false;
    };
  }, []);

  useEffect(() => {
    const handleUnauthorized = () => {
      localStorage.removeItem(TOKEN_KEY);
      setUser(false);
    };
    window.addEventListener("treeplet:unauthorized", handleUnauthorized);
    return () => window.removeEventListener("treeplet:unauthorized", handleUnauthorized);
  }, []);

  const login = useCallback(async (email, password) => {
    const data = await loginRequest(email, password);
    localStorage.setItem(TOKEN_KEY, data.access_token);
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(() => {
    void logoutRequest().catch(() => {});
    localStorage.removeItem(TOKEN_KEY);
    setUser(false);
  }, []);

  return <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>;
};

export function formatApiErrorDetail(detail) {
  if (detail == null) return "No se pudo iniciar sesión. Inténtalo de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
